import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { CalendarCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-hierarchy-list.response';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { CalendarBadge, CalendarHierarchyCardItemComponent } from './calendar-hierarchy-card-item/calendar-hierarchy-card-item.component';

/**
 * Une culture du calendrier, dans sa carte ; une famille de plusieurs cultures
 * (« Laitues ») se déplie dans la même carte au toucher, une culture seule
 * ouvre son guide. Repliée, la famille garde ses lignes hors de portée (`inert`).
 */
@Component({
  selector: 'vw-calendar-hierarchy-card',
  imports: [CalendarHierarchyCardItemComponent],
  templateUrl: './calendar-hierarchy-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './calendar-hierarchy-card.component.scss',
})
export class CalendarHierarchyCardComponent {
  @Input() hierarchy: CalendarCultivationHierarchyListResponse;
  /** Badge d'une culture (« En stock », « Au potager »), par uid de culture. */
  @Input() badgeOf: (cultivationUid: string) => CalendarBadge = () => null;

  @Output() cultivationSelected = new EventEmitter<CalendarCultivationListResponse>();

  isOpen = false;

  get isGroup(): boolean {
    return this.hierarchy.cultivations.length > 1;
  }

  /** Le badge d'une famille : « Au potager » prime sur « En stock ». */
  get hierarchyBadge(): CalendarBadge {
    const badges = this.hierarchy.cultivations.map((c) => this.badgeOf(c.uid));
    return badges.includes('garden') ? 'garden' : badges.includes('stock') ? 'stock' : null;
  }

  onParentClick() {
    if (this.isGroup) {
      this.isOpen = !this.isOpen;
    } else {
      this.cultivationSelected.emit(this.hierarchy.cultivations[0]);
    }
  }

  onChildClick(cultivation: CalendarCultivationListResponse) {
    this.cultivationSelected.emit(cultivation);
  }
}
